export const ASYNC_PROFILE = 'profile'
export const ASYNC_STORE_LIST = 'storeList'
export const ASYNC_STORE_FOCUS = 'storeFocus'
export const ASYNC_STORE = 'storeFocus/store'
export const ASYNC_THRESHOLD_PROFILES = 'thresholdProfiles'
